// @ts-nocheck TODO(ICFE-1029): use actual query types
import { MetaProps } from 'react-helmet-async';

import { IStaticPage, Maybe } from 'generated/sanity-graphql';
import { isNotNull } from 'utils/is-not-null';

export const getTitle = (page: IStaticPage): string =>
  page.metaTags?.title?.locale ?? page.localeTitle?.locale ?? page.title ?? '';

const getMetaProperties = ([key, value]: [string, Maybe<string>]): MetaProps | null => {
  if (!value) {
    return null;
  }

  const propertyOrName: 'property' | 'name' = key.startsWith('og:') ? 'property' : 'name';
  return {
    [propertyOrName]: key,
    content: value,
  };
};

export const getMeta = (page: IStaticPage): MetaProps[] => {
  const metaTags = page.metaTags;
  const ogTags = page.ogTags;

  const tags = [
    ['description', metaTags?.description?.locale],
    ['og:title', ogTags?.title?.locale],
    ['og:description', ogTags?.description?.locale],
    ['og:url', ogTags?.url?.locale],
    ['og:image', ogTags?.imageUrl?.locale],
  ];

  return tags.map(getMetaProperties).filter(isNotNull);
};

export const getStaticPath = (pathname: string) =>
  // Remove first and last slash to check the "staticPath"
  pathname.replace(/^\/|\/$/g, '');
